import ApiService from '../../service/apiServiceMaster.js';
const querystring = require('querystring')
var ModuleService = {

    findAll: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "modules"
            $options.method = "get"

            if ($data) {
                $options.url = "modules?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },

    // getParentMenuData: function($data) {
    //     return new Promise(function(resolve, reject) {
    //         let $options = {};
    //         $options.url = "getParentMenuData"
    //         $options.method = "get"

    //         if ($data) {
    //             $options.url = "getParentMenuData?" + querystring.stringify($data)
    //             console.log($options.url)
    //         }
    //         ApiService.request($options)
    //         .then(response => {
    //             console.log('test');
    //             resolve(response.data.data)
    //         }).catch(error => {
    //             reject(error);
    //         })
    //     });

    // },
    // getParentMenuList: function($data) {
    //     return new Promise(function(resolve, reject) {
    //         let $options = {};
    //         $options.url = "getParentMenu"
    //         $options.method = "get"

    //         if ($data) {
    //             $options.url = "getParentMenu?" + querystring.stringify($data)
    //             console.log($options.url)
    //         }
    //         ApiService.request($options)
    //         .then(response => {
    //             console.log('test');
    //             resolve(response.data.data)
    //         }).catch(error => {
    //             reject(error);
    //         })
    //     });

    // },
  
    findOne: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "modules/" + $data
            console.log($options.url)
            $options.method = "get"
            if (!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                    // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });

    },
    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "modules/" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        })
    },
    save: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "modules" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },

    create: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "modules";
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    }
};
export default ModuleService;